// Libs
import moment from 'moment';

import { getRotaryYear } from '@utils/datetime';

import {
  getIsConferenceManager,
  isPastConference,
} from '@domui-use-cases/districts/conferences';
import {
  ConferencesAccessLvl,
  GetConferencesResult,
} from '@domui-use-cases/districts/conferences/type';

export const getActionsConfig = (
  conference: GetConferencesResult,
  districtId: string,
  conferenceAccessLvls?: ConferencesAccessLvl[] | null
) => {
  const RY = Number(getRotaryYear());
  const {
    relatedRotaryYear,
    startDate,
    endDate,
    districtId: conferenceDistrictId,
    id: conferenceId,
  } = conference;

  const getRelatedRotaryYear = (relatedRotaryYear: string): string => {
    const relatedRY = relatedRotaryYear.split('-');
    if (relatedRY.length > 1) {
      const second = relatedRY[1];
      return second.length === 2 ? `${+second + 2000}` : second;
    }
    return relatedRotaryYear;
  };

  const isMyDistrict = conferenceDistrictId === districtId;

  const isPastConf = isPastConference(endDate);

  const isThisYear =
    RY === Number(getRelatedRotaryYear(relatedRotaryYear as string));

  const isOneYearPast =
    RY - Number(getRelatedRotaryYear(relatedRotaryYear as string)) === 1;

  const isConferenceManager = getIsConferenceManager(
    getRelatedRotaryYear(relatedRotaryYear as string),
    conferenceId,
    conferenceAccessLvls
  );

  const canRemoveConference = !moment().isBetween(
    startDate,
    endDate,
    'd',
    '[]'
  );

  return {
    isMyDistrict,
    isPastConf,
    isOneYearPast,
    isThisYear,
    canEditConference: isConferenceManager && !isPastConf,
    canRemoveConference,
  };
};
